import CourseLinkButton from './CourseLinkButton';

export default CourseLinkButton;
